declare module '@mui/material/Tooltip' {
  interface TooltipProps {
    variant?: 'light' | 'dark';
  }
}
export const MuiTooltip = {
  defaultProps: {
    placement: 'right-end',
    arrow: true,
    variant: 'light',
  },
  styleOverrides: {
    tooltip: {
      fontFamily: 'Avenir Next World',
      fontSize: '1.6rem',
      fontWeight: 400,
      lineHeight: 26 / 16,
      maxWidth: 380,
      display: 'inline-block',
      boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
      variants: [
        {
          props: { variant: 'light' },
          style: {
            backgroundColor: 'white',
            color: '#000000c4',
          },
        },
        {
          props: { variant: 'dark' },
          style: {
            backgroundColor: '#3C3C3C',
          },
        },
      ],
    },
    arrow: {
      variants: [
        {
          props: { variant: 'light' },
          style: {
            color: 'white',
          },
        },
        {
          props: { variant: 'dark' },
          style: {
            color: '#3C3C3C',
          },
        },
      ],
    },
  },
};
